import {
    GET_REFERRAL,
    GET_REFERRAL_FAILURE,
    GET_REFERRAL_SUCCESS,
    GET_SHOP_ALL,
    GET_SHOP_ALL_FAILURE,
    GET_SHOP_ALL_SUCCESS
} from './mutation-types'

export default {
  state: {
  },
  getters: {
  },
  actions: {
    [GET_SHOP_ALL] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: '/asovi/referrals/get_shops' })
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(GET_SHOP_ALL_FAILURE)
                reject(res.data.error)
              } else {
                commit(GET_SHOP_ALL_SUCCESS)
                resolve(res.data)
              }
            }
          })
          .catch(err => {
            commit(GET_SHOP_ALL_FAILURE)
            reject(err)
          })
      })
    },
    [GET_REFERRAL] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', {url: '/asovi/referrals', data: params})
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(GET_REFERRAL_FAILURE)
                reject(res.data.error)
              } else {
                commit(GET_REFERRAL_SUCCESS)
                resolve(res.data)
              }
            }
          })
          .catch(err => {
            commit(GET_REFERRAL_FAILURE)
            reject(err)
          })
      })
    }
  },
  mutations: {
    [GET_SHOP_ALL_FAILURE] () {
      console.log('GET_SHOP_ALL_FAILURE')
    },
    [GET_SHOP_ALL_SUCCESS] (state, data) {
      console.log('GET_SHOP_ALL_SUCCESS')
    },
    [GET_REFERRAL_FAILURE] () {
      console.log('GET_REFERRAL_FAILURE')
    },
    [GET_REFERRAL_SUCCESS] (state, data) {
      console.log('GET_REFERRAL_SUCCESS')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/referral.js